module.exports = __webpack_public_path__ + "img/SISGEOWEBSALA2.42de2ec9.svg";